import { GlDisclosureDropdown, GlDisclosureDropdownItem, GlIcon, GlLoadingIcon, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { reportToSentry } from '~/ci/utils';
import { confirmAction } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/confirm_via_gl_modal/confirm_via_gl_modal.js?vue3';
import { s__, __, sprintf } from '~/locale';
import Tracking from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import GlCountdown from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/gl_countdown.vue?vue3';
import { confirmJobConfirmationMessage } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/pipeline_details/graph/utils.js?vue3';
import { TRACKING_CATEGORIES, DEFAULT_MANUAL_ACTIONS_LIMIT } from '../../constants';
import getPipelineActionsQuery from '../graphql/queries/get_pipeline_actions.query.graphql';
import jobPlayMutation from '../../jobs_page/graphql/mutations/job_play.mutation.graphql';
export default {
    name: 'PipelinesManualActions',
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        GlCountdown,
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlIcon,
        GlLoadingIcon
    },
    mixins: [
        Tracking.mixin()
    ],
    props: {
        fullPath: {
            type: String,
            required: true
        },
        iid: {
            type: Number,
            required: true
        }
    },
    emits: [
        'refresh-pipeline-table'
    ],
    apollo: {
        actions: {
            query: getPipelineActionsQuery,
            variables () {
                return {
                    fullPath: this.fullPath,
                    iid: this.iid,
                    limit: DEFAULT_MANUAL_ACTIONS_LIMIT
                };
            },
            skip () {
                return !this.hasDropdownBeenShown;
            },
            update ({ project }) {
                return project?.pipeline?.jobs?.nodes || [];
            },
            error (err) {
                reportToSentry(this.$options.name, err);
            }
        }
    },
    data () {
        return {
            isLoading: false,
            actions: [],
            hasDropdownBeenShown: false,
            isDropdownVisible: false
        };
    },
    computed: {
        isActionsLoading () {
            return this.$apollo.queries.actions.loading;
        },
        isDropdownLimitReached () {
            return this.actions.length === DEFAULT_MANUAL_ACTIONS_LIMIT;
        }
    },
    methods: {
        async onClickAction (action) {
            if (action.scheduledAt) {
                const confirmationMessage = sprintf(s__('DelayedJobs|Are you sure you want to run %{jobName} immediately? Otherwise this job will run automatically after its timer finishes.'), {
                    jobName: action.name
                });
                const confirmed = await confirmAction(confirmationMessage);
                if (!confirmed) {
                    return;
                }
            } else if (action.detailedStatus.action.confirmationMessage) {
                const confirmed = await confirmJobConfirmationMessage(action.name, action.detailedStatus.action.confirmationMessage);
                if (!confirmed) {
                    return;
                }
            }
            this.isLoading = true;
            this.$apollo.mutate({
                mutation: jobPlayMutation,
                variables: {
                    id: action.id
                }
            }).then(()=>{
                this.isLoading = false;
                this.$emit('refresh-pipeline-table');
            }).catch((err)=>{
                this.isLoading = false;
                createAlert({
                    message: __('An error occurred while making the request.')
                });
                reportToSentry(this.$options.name, err);
            });
        },
        fetchActions () {
            this.isDropdownVisible = true;
            this.hasDropdownBeenShown = true;
            this.$apollo.queries.actions.refetch();
            this.trackClick();
        },
        hideAction () {
            this.isDropdownVisible = false;
        },
        trackClick () {
            this.track('click_manual_actions', {
                label: TRACKING_CATEGORIES.table
            });
        },
        jobItem (job) {
            return {
                text: job.name,
                extraAttrs: {
                    disabled: !job.canPlayJob
                }
            };
        }
    }
};
